import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import html2pdf from 'html2pdf.js';
import mammoth from 'mammoth';

function WordToPdf() {
  const [wordFile, setWordFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [htmlContent, setHtmlContent] = useState('');

  const handleWordUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setWordFile(file);
    }
  };

  const convertWordToPdf = async () => {
    if (!wordFile) return;

    setLoading(true);
    setError(null);

    try {
      // Read DOCX file and convert to HTML
      const arrayBuffer = await wordFile.arrayBuffer();
      const { value: html } = await mammoth.convertToHtml({ arrayBuffer });
      setHtmlContent(html);
      
      // Convert HTML to PDF
      const element = document.createElement('div');
      element.innerHTML = html;
      document.body.appendChild(element);

      const opt = {
        margin: 1,
        filename: 'document.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };
      
      html2pdf().from(element).set(opt).save();

      document.body.removeChild(element);
    } catch (err) {
      setError('An error occurred while converting Word to PDF.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="word-to-pdf">
      <h2>Word to PDF</h2>
      <label htmlFor="word-upload" className="upload-button">
        <FontAwesomeIcon icon={faFileUpload} /> Upload Word File
        <input
          id="word-upload"
          type="file"
          accept=".doc,.docx"
          onChange={handleWordUpload}
          style={{ display: 'none' }}
        />
      </label>
      <button onClick={convertWordToPdf} disabled={loading} className="convert-button">
        <FontAwesomeIcon icon={faFilePdf} /> Convert to PDF
      </button>
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}
    </div>
  );
}

export default WordToPdf;
